module.exports = __webpack_public_path__ + "static/media/frames_Q5.39ac5474.png";